<template>
  <section class="mt-3">

    <!-- Horizontal stepper -->
    <div class="hidden-xs-only">
      <h2>{{ $t('overview.process') }}</h2>
      <v-stepper
        v-model="colouredSteps"
        alt-labels
      >
        <v-stepper-header class="hidden-xs-only">
          <template v-for="(item, index) in filteredSteps">
            <v-stepper-step
              class="pa-3 pt-4"
              :key="'step' + item._randomId"
              :step="index + 1"
              :complete="index < activeStepIndex"
            >{{item.title}}</v-stepper-step>
            <v-divider
              v-if="index != filteredSteps.length - 1"
              :key="'divider' + item._randomId"
            ></v-divider>
          </template>
        </v-stepper-header>
        <v-stepper-items>
          <template v-for="(item, index) in filteredSteps">
            <v-stepper-content
              class="pa-3"
              :key="'content' + item._randomId"
              :step="index + 1"
            >
              <p class="mb-2 description">{{item.description}}</p>
            </v-stepper-content>
          </template>
        </v-stepper-items>
      </v-stepper>
    </div>

    <!-- Vertical stepper -->
    <div class="hidden-sm-and-up">
      <h2>{{ $t('overview.process') }}</h2>
      <v-stepper
        v-model="colouredSteps"
        vertical
      >
        <template v-for="(item, index) in filteredSteps">
          <v-stepper-step
            :key="'step' + item._randomId"
            :step="index + 1"
            :complete="index < activeStepIndex"
          >{{item.title}}</v-stepper-step>
          <v-stepper-content
            :key="'content' + item._randomId"
            :step="index + 1"
          >
            <p>{{item.description}}</p>
          </v-stepper-content>
        </template>
      </v-stepper>
    </div>

  </section>
</template>

<script>
import _ from 'lodash'
import errandService from '@/core/services/errand-service'

export default {
  data: () => ({
    colouredSteps: 0
  }),
  computed: {
    filteredSteps() {
      return !this.currentStep.mandatory
        ? [this.currentStep]
        : _.filter(errandService.getErrandSteps(), 'mandatory')
    },
    currentStep() {
      return errandService.getCurrentStep()
    },
    activeStepIndex() {
      return _.findIndex(this.filteredSteps, this.currentStep)
    }
  },
  created() {
    this.colouredSteps = this.activeStepIndex + 1
  }
}
</script>

<style lang="scss" scoped>
.description {
  @include font-size(s);
}
</style>
